
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thrive-login",
      function () {
        return require("private-next-pages/thrive-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thrive-login"])
      });
    }
  